<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="680"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Divider orientation="left" class="text-primary">基本信息</Divider>
                    <Col span="24">
                        <FormItem label="单位名称" prop="company">
                            <Input v-model="Forms.company" clearable placeholder="单位名称" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="供应商类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable  placeholder="供应商类型">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.type_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="供应商等级" prop="level">
                            <Select v-model="Forms.level" clearable filterable  placeholder="供应商等级">
                                <Option v-for="(item,index) in levelList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="主营产品" prop="business_id">
                            <Select v-model="Forms.business_id" filterable clearable multiple placeholder="主营产品">
                                <Option v-for="(item,index) in businessList" :key="index" :value="item.b_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系人" prop="name">
                            <Input v-model="Forms.name" clearable placeholder="联系人姓名" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="手机号码" prop="mobile">
                            <Input v-model="Forms.mobile" clearable placeholder="联系人电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="phone">
                            <Input v-model="Forms.phone" clearable placeholder="联系电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="微信号" prop="wechat">
                            <Input v-model="Forms.wechat" clearable placeholder="微信号" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="电子邮箱" prop="email">
                            <Input v-model="Forms.email" clearable placeholder="电子邮箱" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="供应商地址" prop="address">
                            <Input v-model="Forms.address" clearable placeholder="详细地址" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="业务员" prop="saler_id">
                            <Select v-model="Forms.saler_id" clearable filterable  placeholder="业务员">
                                <Option v-for="(item,index) in salerList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="合同与资质" prop="image">
                            <Upload
                                :show-upload-list="false"
                                :action="upload_url"
                                :headers = "{'token': $store.state.token}"
                                :format="['jpg','jpeg','png','gif']"
                                :max-size="10 * 1024"
                                :on-success="handleSuccess"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                :before-upload="handleBeforeUpload">
                                <div class="uploads">
                                    <div class="upload-images-icon cursor" v-if="Forms.image.length < 10">
                                        <Icon type="md-cloud-upload" size="24" />
                                        <span>点击上传</span>
                                    </div>
                                    <div class="upload-images" v-for="(item,index) in Forms.image" :key="index" @click.stop="">
                                        <img :src="site_url + item">
                                        <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                        <div class="del" @click.stop="PhotoDelete(index)"><Icon type="md-close" /></div>
                                    </div>
                                </div>
                            </Upload>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="仅内部可见" />
                        </FormItem>
                    </Col>
                    <Divider orientation="left" class="text-primary">收款账户</Divider>
                    <Col span="12">
                        <FormItem label="收款账户" prop="bank_account">
                            <Input v-model="Forms.bank_account" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="账户实名" prop="bank_real_name">
                            <Input v-model="Forms.bank_real_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="bank_name">
                            <Input v-model="Forms.bank_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户地址" prop="bank_address">
                            <Input v-model="Forms.bank_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>
    </Drawer>
</template>

<script>

import {getCompanyConfig, saveCompany, getCompanyDetail} from "@/apis/company";

export default {
    name: 'CompanyCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增供应商',
            isBox : false,
            typeList: [],
            businessList: [],
            levelList: [],
            salerList: [],

            upload_url : this.$uploadApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',

            Forms : {
                company_id: '',
                company: '',
                type_id: '',
                level: '',
                business_id: [],
                name: '',
                mobile: '',
                phone: '',
                wechat: '',
                email: '',
                address: '',
                image: [],
                saler_id: '',
                bank_account: '',
                bank_real_name: '',
                bank_name: '',
                bank_address: '',
                remark: '',
                status: 3
            },
            Rules : {
                company: [
                    { required: true, type: 'string',  message: '请输入单位名称', trigger: 'blur' }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择供应商类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                business_id: [
                    { required: true, type: 'array',  message: '请选择主营产品', trigger: 'change'}
                ],
                name: [
                    { required: true, type: 'string',  message: '请输入联系人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, type: 'string',  message: '请输入手机号码', trigger: 'blur' }
                ],
                saler_id: [
                    { required: true, type: 'number',  message: '请选择业务员', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
            }
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025/12/17 10:48
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/17 10:48
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.image.push(res.data.url);
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        GetConfig(){
            let that = this;
            getCompanyConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.businessList = e.data.businessList ?? [];
                that.levelList = e.data.levelList ?? [];
                that.salerList = e.data.salerList ?? [];
            })
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(company_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getCompanyDetail(company_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                    if(v === 'status' || v === 'type_id' || v === 'level' || v === 'saler_id' ) {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'image' || v === 'business_id' ) {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        edit(company_id){
            this.isBox = true;
            this.title = '编辑供应商';
            this.GetConfig();
            if(company_id) this.GetDetail(company_id);
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveCompany(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增供应商';
            this.$refs['Forms'].resetFields();
            this.Forms.typeList = [];
            this.Forms.businessList = [];
            this.Forms.levelList = [];
            this.Forms.salerList = [];
            this.Forms.company_id = '';
            this.Forms.status = 3;
            this.Forms.image = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
